import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {browserHistory} from 'react-router';
import {Request, GET} from 'requests';
import {default as RequestsMixin, IS_DONE} from 'requests/RequestsMixin';
import {default as Tooltip} from 'components/Tooltip';
import Alert from 'components/Alert';
import MainNavMixin from '../mixins/MainNavMixin';
import KitLogo from './KitLogo';
import KitSettings from './KitSettings';
import PublishButton from './PublishButton';
import ResourcesMatching from 'requests/components/ResourcesMatching';
import Requesting from 'requests/components/Requesting';
import Done from 'requests/components/Done';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const KitController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
    children: PropTypes.object,
  },

  mixins: [MainNavMixin, RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    const {kitToken} = this.props;

    return {
      showKitSettings: false,
      nameFocused: false,
      embedCodeUrl: `https://${FORT_AWESOME_USE_URL}/${kitToken}.js`,
      embedCodeScriptTag: `<script src="https://${FORT_AWESOME_USE_URL}/${kitToken}.js"></script>`,
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });

    this.setRequest({
      workingSetArchives: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-archives'],
      }),
    });
  },

  transitions(register) {
    register({
      request: this.requests.kit,
      to: IS_DONE,
      call(rm) {
        const kit = rm.type(this.requests.kit, 'kits').get()

        if (kit.version < KIT_LATEST_VERSION) {
          browserHistory.push(`/kits/${this.props.kitToken}/migrate?next=${encodeURIComponent(window.location.pathname)}`);
        }
      },
    });
  },

  mostRecentWorkingSetArchive() {
    const rm = this.resourceManager();
    const workingSetArchives = rm.type(this.requests.workingSetArchives, 'working-set-archives').all();

    let value = null;

    if (!workingSetArchives.isEmpty()) {
      value = workingSetArchives
        .sortBy((workingSetArchive) => workingSetArchive.createdAt.unix())
        .reverse()
        .first();
    }

    return value;
  },

  handleKitSettingsOpened(event) {
    event.preventDefault();

    this.setState({showKitSettings: true});
  },

  handleKitSettingsClosed() {
    this.setState({showKitSettings: false});
  },

  handleNameFocused() {
    this.setState({nameFocused: !this.state.nameFocused});
  },

  handleKitPublishing() {
    this.refreshKitMessages();
  },

  handleKitPublished() {
    this.refreshKitMessages();
    this.refreshKitWorkingSetArchives();
  },

  refreshKitMessages() {
    this.setRequest({
      refreshKitMessages: new Request({
        url: ['api', 'kits', this.props.kitToken, 'messages'],
        method: GET,
        useCache: false,
      }),
    });
  },

  refreshKitWorkingSetArchives() {
    this.setRequest({
      workingSetArchives: new Request({
        url: ['api', 'kits', this.props.kitToken, 'working-set-archives'],
        method: GET,
        useCache: false,
      }),
    });
  },

  handleKitPublishedFirstTime() {
    this.setState({showEmbedCode: true});
  },

  renderMain() {
    const {
      dispatch,
      children,
      kitToken,
    } = this.props;
    const {
      kit: kitRequest,
      subscription: subscriptionRequest,
    } = this.requests;
    const {
      showKitSettings,
      nameFocused,
    } = this.state;

    const rm = this.resourceManager();
    const subscription = rm.type(subscriptionRequest, 'subscriptions').get();
    const kit = rm.type(kitRequest, 'kits').find({token: kitToken});
    const popover = (nameFocused) ? <Tooltip icon="ficon-pencil" content="Edit Kit Name" /> : null;

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <div className="kit-summary gg gg-middle m-xs-b-sm">
          <div className="gg-col min-width p-xs-r-md">
            <KitLogo kitToken={kit.token} />
          </div>
          <h1 className="text-3x gg-col kit-title">
            <span>
              <a className="link-dashed-none" href="#" onClick={this.handleKitSettingsOpened} onMouseOver={this.handleNameFocused} onMouseOut={this.handleNameFocused}>
                {popover}
                {kit.name}
              </a>
            </span>
          </h1>
          <KitSettings kit={kit} showModal={showKitSettings} onClosed={this.handleKitSettingsClosed} />
          <div className="gg-col text-xs-right text-muted">
            <PublishButton
              kit={kit}
              dispatch={dispatch}
              onPublishing={this.handleKitPublishing}
              onPublished={this.handleKitPublished}
              onFirstTimePublished={this.handleKitPublishedFirstTime}
            />
          </div>
        </div>
        {this.renderNav(kit, subscription, {workingSetArchive: this.mostRecentWorkingSetArchive()})}
        <div className="kit-components">
          {children}
        </div>
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(KitController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/KitController.js